module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Regular.2a7d15a3.woff2";